/**
 * Catalogue category codes that should not be offered on the Appliance Details step.
 *
 * The `/catalogue` endpoint returns the same category set across the Whirlpool family brands, but not
 * every category is applicable for every brand, so the ones that aren't get filtered out here
 * rather than being hidden per-tenant in the UI.
 *
 * NOTE: This only filters
 *
 * Codes are compared case-insensitively, so they can be listed in whichever case reads best.
 */
export const excludedCategoryCodes: Record<string, string[]> = {
  JNAIR: ['LAUN', 'STMX'],
};
